import Vue from "vue";

export function substring(value, length) {
  return value.substring(0, length);
}

Vue.filter("substring", substring);

export default substring;
